// extracted by mini-css-extract-plugin
export default {"getInTouch":"GetInTouch__getInTouch-FtnZ","title":"GetInTouch__title-MPwb","header":"GetInTouch__header-d5An","description":"GetInTouch__description-Ck0H"};